var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "currentWidth",
    height: "currentHeight",
    viewBox: "0 0 90 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M53.433 7.062l34.244 65.225a9.524 9.524 0 01-8.433 13.951H10.757a9.524 9.524 0 01-8.432-13.95L36.568 7.061a9.524 9.524 0 0116.865 0z",
    stroke: "#FF4057",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.743 57.133V27.42c0-.838.762-1.524 1.523-1.6h7.315c.838.076 1.524.762 1.524 1.6v29.714c0 .914-.686 1.524-1.524 1.6h-7.315c-.761-.076-1.523-.686-1.523-1.6zm.152 14.172v-6.553c0-.838.686-1.447 1.524-1.524h7.39c.762.077 1.448.686 1.448 1.524v6.553c0 .838-.686 1.523-1.448 1.6h-7.39c-.838-.077-1.524-.762-1.524-1.6z",
    fill: "#FF4057"
  })));
}

export default SvgWarning;